import { RiFlowChart } from "@itandi/itandi-bb-ui";
import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import { useDealWorkflows } from "~/hooks/deals/useDealWorkflows";
import { isAfterTheFactApprovalWorkflow } from "~/models/DealWorkflow";
import { itandiTaskWorkflowUrl } from "~/utils/ItandiTaskPath";
import Styles from "./CompanyWorkflowSettingNavigation.module.scss";

type Props = {
	dealId: number;
};

export function AfterTheFactApprovalWorkflowNavigation({ dealId }: Props) {
	const { notify } = useNotification();
	const { data: workflows, isLoading } = useDealWorkflows(dealId, () => {
		notify({
			content: "ワークフローの取得に失敗しました。",
			variant: "error"
		});
	});

	if (isLoading || workflows === null) {
		return null;
	}

	return (
		<>
			{workflows.map((workflow) => {
				if (
					workflow.status !== "progress" ||
					!isAfterTheFactApprovalWorkflow(workflow)
				) {
					return null;
				}

				return (
					<div className={Styles.NavigationBlock} key={workflow.id}>
						<div className={Styles.IconWrapper}>
							<RiFlowChart className={Styles.Icon} />
						</div>
						<div className={Styles.NavigationContent}>
							<div>
								<a
									className={Styles.TitleLink}
									href={itandiTaskWorkflowUrl(workflow.id)}
									rel="noopener noreferrer"
									target="_blank"
								>
									{workflow.name}
								</a>
								<p className={Styles.Description}>
									事後承認のワークフローが進行中です。
								</p>
							</div>
						</div>
					</div>
				);
			})}
		</>
	);
}
